module.exports = __webpack_public_path__ + "static/media/omdb-movies-search-movie-mobile.a727a711.jpg";